import _get from 'lodash/get';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
function getOptionLabel() {
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  return "".concat(option.shipmentNumber);
}
function getOptionValue(option) {
  return _get(option, 'id', '');
}
export default {
  getOptionLabel: getOptionLabel,
  getOptionValue: getOptionValue
};